import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Region } from 'shared-lib';
import { Area } from '../../../models/area.model';
import { RegionService } from 'shared-lib';
import { AreaService } from 'shared-lib';
import { ToastrService } from 'ngx-toastr';
import { TariffService } from '../../../services/tariff.service';
import { Tariff } from '../../../models/tariff.model';
import { OptionObj } from 'shared-lib';
import { CustomerService } from '../../../services/customer.service';
import { ClientType, CustomerCrudAppliedFilter, CustomerCrudFilter, ServiceType, TypeOfConnection } from '../../../models/customer.model';
import { forkJoin } from 'rxjs';
import { UtilitySharedService } from '../../../shared/_services/utility-shared.service';

export enum DateType {
  LastUpdateTime = 2,
  TaggedDate = 3,
  ValidatedDate = 6,
}

@Component({
  selector: 'app-customer-crud-filter-window',
  templateUrl: './customer-crud-filter-window.component.html',
  styleUrl: './customer-crud-filter-window.component.scss',
  standalone: false,
})
export class CustomerCrudFilterWindowComponent implements OnInit, OnChanges{

  constructor(
    private regionService: RegionService,
    private areaService: AreaService,
    private toastr: ToastrService,
    private tariffService: TariffService,
    private customerService: CustomerService,
    private utilitySharedService: UtilitySharedService
  ) {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['appliedFiltersInput']) {
      this.appliedFilters = this.appliedFiltersInput;
      this.loadAppliedFilters();
    }
  }

  ngOnInit(): void {
    this.getData();
  }

  @Output() close = new EventEmitter<void>();
  @Output() addFilter = new EventEmitter<CustomerCrudFilter>();
  @Output() addFilterCards = new EventEmitter<{ label: string, value: any }[]>();
  @Input() appliedFiltersInput: CustomerCrudAppliedFilter[] = [];
  


  openedFilters: string[] = [];
  regionSearchText: string = '';
  districtSearchText: string = '';
  selectedRegion: Region | null = null;
  areas: Area[] = [];
  allAreas: Area[] = [];
  regions: Region[] = [];
  selectedAreas: {id: number, name: string}[] = [];
  tariffSearchText: string = '';
  sltSearchText: string = '';
  utilityId: number;
  tariffs: Tariff[] = [];
  filteredTariffs: Tariff[] = [];
  selectedTariff: Tariff | null = null;
  sltOptions: OptionObj[] = [];
  filteredSltOptions: OptionObj[] = [];
  isOpen: boolean = true;

  selectedClientType: number | null = null;
  selectedServiceType: number | null = null;
  selectedSltStatus: number | null = null;
  selectedStatus: number | null = null;
  selectedPhase: number | null = null;
  filter: CustomerCrudFilter = new CustomerCrudFilter();
  appliedFilters: CustomerCrudAppliedFilter[] = [];


  clientTypes = [
    { label: 'COMMON.CLIENT_TYPE_OPTIONS.COMPANY', value: ClientType.Company },
    { label: 'COMMON.CLIENT_TYPE_OPTIONS.EMBASSY_FOREIGN_INSTITUTION', value: ClientType.EmbassyForeignInstitution },
    { label: 'COMMON.CLIENT_TYPE_OPTIONS.INDIVIDUAL', value: ClientType.Individual },
    { label: 'COMMON.CLIENT_TYPE_OPTIONS.GOVERNMENT', value: ClientType.Government },
    { label: 'COMMON.CLIENT_TYPE_OPTIONS.ASSEMBLY', value: ClientType.Assembly },
  ];

  serviceTypes = [
    { label: 'COMMON.SERVICE_TYPE.LARGE', value: ServiceType.Large },
    { label: 'COMMON.SERVICE_TYPE.SMALL', value: ServiceType.Small },
    { label: 'COMMON.SERVICE_TYPE.PREPAID', value: ServiceType.Prepaid },
    { label: 'COMMON.SERVICE_TYPE.AMR', value: ServiceType.AMR }
  ]

  statusOptions = [
    { label: 'COMMON.PENDING_SETUP', value: 0 },
    { label: 'COMMON.ASSET_STATUS.COMPLETE', value: 1 }
  ]

  phaseOptions = [
    { label: 'COMMON.CUSTOMER.PHASE_OPTIONS.SINGLE', value: TypeOfConnection.SinglePhase },
    { label: 'COMMON.CUSTOMER.PHASE_OPTIONS.THREE', value: TypeOfConnection.ThreePhase }
  ]


  loadAppliedFilters() {
    if (this.appliedFiltersInput?.length > 0) {
      this.appliedFilters = [...this.appliedFiltersInput];
      this.selectedAreas = [];
      this.selectedTariff = null;
      this.selectedClientType = null;
      this.selectedServiceType = null;
      this.selectedSltStatus = null;
      this.selectedStatus = null;
      this.selectedPhase = null;

      this.appliedFilters.forEach(filter => {
        switch (filter.label) {
          case 'COMMON.UT.SINGLE':
            const area = this.allAreas.find(a => a.name === filter.value);
            if (area && !this.selectedAreas.some(sa => sa.id === area.id)) {
              this.selectedAreas.push({ id: area.id, name: area.name });
            }
            break;
          case 'COMMON.TARIFF.SINGLE':
            const tariff = this.tariffs.find(t => t.name === filter.value);
            if (tariff) this.selectedTariff = tariff;
            break;
          case 'COMMON.MBC_DETAILS.CLIENT_TYPE':
            const customerType = this.clientTypes.find(type => type.label === filter.value);
            if (customerType) this.selectedClientType = customerType.value;
            break;
          case 'COMMON.SERVICE_TYPE.TITLE':
            const serviceType = this.serviceTypes.find(type => type.label === filter.value);
            if (serviceType) this.selectedServiceType = serviceType.value;
            break;
          case 'CRUD.SLT_STATUS':
            const sltStatus = this.sltOptions.find(option => option.value === filter.value);
            if (sltStatus) this.selectedSltStatus = sltStatus.key;
            break;
          case 'COMMON.VALIDATION_STATUS':
            const status = this.statusOptions.find(option => option.label === filter.value);
            if (status) this.selectedStatus = status.value;
            break;
          case 'COMMON.CUSTOMER.CUSTOMER_PHASE':
            const phase = this.phaseOptions.find(option => option.label === filter.value);
            if (phase) this.selectedPhase = phase.value;
            break;
        }
      });
    }
  }

  getData() {
    forkJoin({
      regions: this.regionService.getAllForSelect(),
      areas: this.areaService.getAllForSelect(),
      tariffs: this.tariffService.getAllForSelect(this.utilityId),
      sltStatuses: this.customerService.getSltStatusesForOptions()
    }).subscribe({
      next: ({ regions, areas, tariffs, sltStatuses }) => {
        if (regions.body?.status === 200 || regions.body?.status === 'OK') {
          this.regions = regions.body.data.map((region: Region) => ({
            ...region,
            isExpanded: false,
          }));
        } else if (regions.status === 204) {
          this.regions = [];
        } else {
          this.toastr.error(regions.body?.message);
        }

        if (areas.body?.status === 200 || areas.body?.status === 'OK') {
          this.allAreas = areas.body.data.map((area: Area) => ({
            ...area,
            checked: false,
          }));
          this.updateAreas();
        } else if (areas.status === 204) {
          this.allAreas = [];
        } else {
          this.toastr.error(areas.body?.message);
        }

        if (tariffs.body?.status === 200 || tariffs.body?.status === 'OK') {
          this.tariffs = tariffs.body.data;
          this.filteredTariffs = tariffs.body.data;
        } else {
          this.toastr.error(tariffs.body?.message);
        }

        if (sltStatuses.body?.status === 200 || sltStatuses.body?.status === 'OK') {
          this.sltOptions = sltStatuses.body.data;
          this.filteredSltOptions = sltStatuses.body.data;
        } else if (sltStatuses.status === 204) {
          this.sltOptions = [];
          this.filteredSltOptions = [];
        } else {
          this.toastr.error(sltStatuses.body?.message);
        }

        this.loadAppliedFilters();
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading data');
      }
    });
  }

  getSltStatuses() {
    this.customerService.getSltStatusesForOptions().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sltOptions = responseData.data;
          this.filteredSltOptions = responseData.data;
        } else if (response?.status == 204) {
          this.sltOptions = [];
          this.filteredSltOptions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectTariff(tariff: Tariff){
    this.selectedTariff = this.selectedTariff === tariff ? null : tariff;
  }

  selectSltStatus(sltStatus: OptionObj){
    this.selectedSltStatus = this.selectedSltStatus === sltStatus.key ? null : sltStatus.key;
  }

  selectClientType(value: number) {
    this.selectedClientType = this.selectedClientType === value ? null : value;
  }

  selectServiceType(value: number) {
    this.selectedServiceType = this.selectedServiceType === value ? null : value;
  }

  selectStatus(value: number) {
    this.selectedStatus = this.selectedStatus === value ? null : value;
  }

  selectPhase(value: number) {
    this.selectedPhase = this.selectedPhase === value ? null : value;
  }

  getTariffs() {
    this.tariffService.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.tariffs = responseData.data;
          this.filteredTariffs = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  filterTariffs(){
    this.filteredTariffs = this.tariffs.filter(tariff =>
      tariff.name.toLowerCase().includes(this.tariffSearchText.toLowerCase())
    );
  }

  filterSltOptions(){
    this.filteredSltOptions = this.sltOptions.filter(slt =>
      slt.value.toLowerCase().includes(this.sltSearchText.toLowerCase())
    );
  }

   isAreaSelected(area: {id: number, name: string}): boolean{
    return this.selectedAreas.some(a => a.id == area.id);
  }

  onAreaSelect(area: {id: number, name: string}, event: Event){
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedAreas.push({id: area.id, name: area.name});
    } else {
      this.selectedAreas = this.selectedAreas.filter(u => u.id !== area.id);
    }
  }

  selectRegion(region: Region) {
    this.selectedRegion = this.selectedRegion === region ? null : region;
    this.updateAreas();
  }

  updateAreas() {
    this.areas = this.allAreas.filter(
      (area) =>
        (!this.selectedRegion || area.regionId === this.selectedRegion.id) &&
        (!this.districtSearchText ||
          area.name.toLowerCase().includes(this.districtSearchText.toLowerCase()))
    );
  }

  get filteredRegions() {
    return this.regions.filter(
      (region) =>
        !this.regionSearchText ||
        region.name.toLowerCase().includes(this.regionSearchText.toLowerCase())
    );
  }

  private getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data.map((region: Region) => ({
            ...region,
            isExpanded: false,
          }));
          this.getAreas();
        } else if (response?.status === 204) {
          this.regions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  private getAreas() {
    this.areaService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data.map((area: Area) => ({
            ...area,
            checked: false,
          }));
          this.updateAreas();
        } else if (response?.status === 204) {
          this.allAreas = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  onCancel() {
    this.close.emit();
    this.isOpen = false;
  }

  onWindowClick(event: MouseEvent) {
    event.stopPropagation();
  }

    toggleFilter(filter: string) {
    const index = this.openedFilters.indexOf(filter);
    if (index > -1) {
      this.openedFilters.splice(index, 1); 
    } else {
      this.openedFilters.push(filter);
    }
  }

  createFilterCards(filter: CustomerCrudFilter): CustomerCrudAppliedFilter[] {
    const appliedFilters: CustomerCrudAppliedFilter[] = [];

    // Create separate cards for each selected area
    this.selectedAreas.forEach(area => {
      appliedFilters.push({
        label: 'COMMON.UT.SINGLE',
        value: area.name
      });
    });

    if (filter.tariffId !== null && this.selectedTariff) {
      appliedFilters.push({
        label: 'COMMON.TARIFF.SINGLE',
        value: this.selectedTariff.name
      });
    }

    if (filter.clientType !== null && this.selectedClientType !== null) {
      const customerTypeLabel = this.clientTypes.find(type => type.value === this.selectedClientType)?.label;
      appliedFilters.push({
        label: 'COMMON.MBC_DETAILS.CLIENT_TYPE',
        value: customerTypeLabel || this.selectedClientType
      });
    }

    if (filter.serviceType !== null && this.selectedServiceType !== null) {
      const serviceTypeLabel = this.serviceTypes.find(type => type.value === this.selectedServiceType)?.label;
      appliedFilters.push({
        label: 'COMMON.SERVICE_TYPE.TITLE',
        value: serviceTypeLabel || this.selectedServiceType
      });
    }

    if (filter.sltStatus !== null && this.selectedSltStatus !== null) {
      const sltStatusLabel = this.sltOptions.find(option => option.key === this.selectedSltStatus)?.value;
      appliedFilters.push({
        label: 'CRUD.SLT_STATUS',
        value: sltStatusLabel || this.selectedSltStatus
      });
    }

    if (filter.customerStatus !== null && this.selectedStatus !== null) {
      const statusLabel = this.statusOptions.find(option => option.value === this.selectedStatus)?.label;
      appliedFilters.push({
        label: 'COMMON.VALIDATION_STATUS',
        value: statusLabel || this.selectedStatus
      });
    }

    if (filter.customerPhase !== null && this.selectedPhase !== null) {
      const phaseLabel = this.phaseOptions.find(option => option.value === this.selectedPhase)?.label;
      appliedFilters.push({
        label: 'COMMON.CUSTOMER.CUSTOMER_PHASE',
        value: phaseLabel || this.selectedPhase
      });
    }

    return appliedFilters;
  }

  onAddFilter() {
    this.filter = {
      ...this.filter,
      tariffId: this.selectedTariff?.id ?? null,
      serviceType: this.selectedServiceType !== null ? this.selectedServiceType : null,
      customerStatus: this.selectedStatus !== null ? this.selectedStatus : null,
      clientType: this.selectedClientType !== null ? this.selectedClientType : null,
      sltStatus: this.selectedSltStatus !== null ? Number(this.selectedSltStatus) : null,
      customerPhase: this.selectedPhase !== null ? this.selectedPhase : null,
      selectedAreas: this.selectedAreas.map(area => area.id),
      selectedRegions: this.selectedRegion ? [this.selectedRegion.id] : []
    };


    const filterCards = this.createFilterCards(this.filter);

    this.addFilter.emit(this.filter);
    this.addFilterCards.emit(filterCards);

    this.onCancel();
  }
}